export enum FormType {
     SECTION, ASSIGNMENT, ASSIGNMENT_INLINE, ASSIGNMENT_NEW_WELCOME, CITATION, COLLECTION
}
